import { Component, Injector, Input, OnInit, Type } from "@angular/core";
import { PageHeaderComponent } from "../page-header/page-header.component";
import { TabsComponent } from "src/app/common/components/core/tabs/tabs.component";
import { Tab } from "src/app/common/interfaces/tab";
import { TabChange } from "src/app/common/interfaces/tab-change";
import { DocumentsComponent } from "./documents/documents.component";
import { BillingDailyNotesComponent } from "./billing-daily-notes/billing-daily-notes.component";
import { CommonModule } from "@angular/common";
import { StorageService } from "src/app/common/services/storage.service";
import { DropdownItem } from "src/app/common/interfaces/dropdown-item.interface";
import { DropdownComponent } from "src/app/common/components/core/dropdown/dropdown.component";
import { CoSignerClient } from "src/app/common/services/co-signer.client";
import { SecurityFeatureUtility } from "src/app/common/services/security-feature.utility";
import { Features } from "src/app/common/enums/features.enum";
import { AppConstants } from "src/app/common/constants/app-constants";
import { distinctUntilChanged, take } from "rxjs";
@Component({
  selector: "app-co-sign",
  templateUrl: "./co-sign.component.html",
  styleUrls: ["./co-sign.component.scss"],
  imports: [
    CommonModule,
    PageHeaderComponent,
    TabsComponent,
    DropdownComponent,
    DocumentsComponent,
    BillingDailyNotesComponent,
  ],
  standalone: true,
})
export class CoSignComponent implements OnInit {
  tabIndex = 0;
  userId: string = "";
  currentFacilityId: string = "";
  customInjector!: Injector;
  canCoSignForTeam: boolean = false;

  public readonly tabMetricMap: Record<string, Type<any>> = {
    Documents: DocumentsComponent,
    "Billing & Daily Notes": BillingDailyNotesComponent,
  };

  tabs: Tab[] = Object.entries(this.tabMetricMap).map(([name]) => ({ name }));
  therapists: DropdownItem[] = [];
  facilitySubscription: any;

  constructor(
    private injector: Injector,
    private storageService: StorageService,
    private cosignClient: CoSignerClient,
    private securityFeatureUtility: SecurityFeatureUtility
  ) {}

  ngOnInit() {
    this.canCoSignForTeam =
          this.securityFeatureUtility.getSecurityFeature(
            Features.CO_SIGN_TEAM,
            false
          ).featureaccess === AppConstants.manage;

    this.facilitySubscription = this.storageService.isSelectedFacility
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(async (facilityId) => {
        if (facilityId) {
          this.currentFacilityId=facilityId;
          this.getTherapist(this.currentFacilityId);

          this.customInjector = Injector.create({
            providers: [{ provide: "userId", useValue: this.userId }],
            parent: this.injector,
          });
          this.tabs = [...this.tabs];
        }
      });

    this.userId = this.storageService.getUserId()!;
    this.currentFacilityId = this.storageService.getSelectedFacilityId()!;
    this.customInjector = Injector.create({
      providers: [{ provide: "userId", useValue: this.userId }],
      parent: this.injector,
    });
    this.getTherapist(this.currentFacilityId);
  }

  getTherapist(facilityid: string) {
    this.cosignClient
      .getCoSignersByFacility(facilityid)
      .subscribe((data: any) => {
        this.therapists = data.responseData;
      });
  }

  tabChange({ to }: TabChange): void {
    this.tabIndex = to;
  }

  get selectedComponent(): Type<any> {
    return Object.values(this.tabMetricMap)[this.tabIndex];
  }

  onTherapistSelected($event: any) {
    this.customInjector = Injector.create({
      providers: [{ provide: "userId", useValue: $event.value }],
      parent: this.injector,
    });
    this.tabs = [...this.tabs];
  }
}
